export default class {
	constructor(obj) {
		this.type = obj.type
		this.icon = obj.icon
		this.comment = obj.comment
		this.inDevelop = obj.inDevelop
        this.title = obj.title
	}
}



// WEBPACK FOOTER //
// ./src/sites/dto/DtoResearchType.js